/*
 * @Author: chenxuelai 2251702447@qq.com
 * @Date: 2023-08-10 15:58:32
 * @LastEditors: chenxuelai 2251702447@qq.com
 * @LastEditTime: 2023-10-30 10:03:55
 * @FilePath: /vue_huaqiang/src/api/credit-note.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from "@/utils/oms-request";
import download from "@/utils/oms-download";
import exp from "constants";


// /credit_note/file/{id} // 替换附件 PUT
export const updateCNfile = (id, data) =>
    request({
        url: `/credit-note/file/${id}`,
        method: "put",
        data
    });
// /credit_note/file/{id} // 删除附件 DELETE
export const deleteCNfile = (params) =>
    request({
        url: `/credit-note/file/${params}`,
        method: "delete",
    });
// /credit_note/file/{id}/remark // 更新附件备注 PUT
export const updateCNFileRemark = (id, data) =>
    request({
        url: `/credit-note/file/${id}/remark`,
        method: "put",
        data
    });
// /credit_note/create PUT
export const createCNFile = (data) =>
    request({
        url: `/credit-note/create`,
        method: "put",
        data
    });
// /credit_note/{id}/file 附件管理 GET
export const getCNFileList = (id: any) =>
    request({
        url: `/credit-note/${id}/file`,
        method: "get"
    });

// /credit_note/{id}/file 上传附件 POST
export const uploadCNFile = (id, data) =>
    request({
        url: `/credit-note/${id}/file`,
        method: "post",
        data
    });
// /credit_note/search
export const getCNList = (params) =>
    request({
        url: `/credit-note/search`,
        method: "get",
        params
    });
// /credit-note/reason-types
export const getCNReasonTypes = () =>
    request({
        url: `/credit-note/reason-types`,
        method: "get"
    });
// /credit_note/create
export const CreateCNOrder = (params) =>
    request({
        url: `/credit-note/create`,
        method: "put",
        params
    });
// 编辑CN
export const updateCNOrder = (params) =>
    request({
        url: `/credit-note/update`,
        method: "put",
        params
    });
// 提交CN审核
// /credit-note/{id}/audits
export const postAudits = (id, data) =>
    request({
        url: `/credit-note/${id}/audits`,
        method: "post",
        data
    });
// 查看CN审核
export const getAudits = (id) =>
    request({
        url: `/credit-note/${id}/audits`,
        method: "get"
    });
// /credit-note/{id}/audit-passed 审核通过
export const auditPassed = (id) =>
    request({
        url: `/credit-note/${id}/audit-passed`,
        method: "post"
    });
// /credit-note/{id}/audit-hangs 审核挂起
export const auditHangs = (id, params) =>
    request({
        url: `/credit-note/${id}/audit-hangs`,
        method: "post",
        params
    });
// /credit-note/{id}/audit-cancel 取消审核
export const auditCancel = (id) =>
    request({
        url: `/credit-note/${id}/audit-cancel`,
        method: "post"
    });
// 导出Word模版
export const downloadExportWord = (id) =>
    download({
        responseType: "blob",
        url: `/credit-note/${id}/export-word`,
        method: "post"
    });
// /claim_form/search
export const claimSearch = (params, data) =>
    request({
        url: `/claim_form/search`,
        method: "post",
        params,
        data
    });
export const claimDetail = (params) =>
    request({
        url: `/credit-note/claim-detail`,
        method: "get",
        params,
    });

export const claimForm = (params, data) =>
    request({
        url: `/credit-note/claim-form`,
        method: "post",
        params,
        data
    });
// /claim_form/{id}/details // 生成索赔单
export const CreateClaim = (id, data) =>
    request({
        url: `/claim_form/${id}/details`,
        method: "put",
        data
    });
export const getClaimDet = (id) => // 索赔单详情
    request({
        url: `/claim_form/${id}/details`,
        method: "get"
    });

// 修改供应商扣款
export const updateSupplierDeduction = (params: any) =>
    request({
        url: `/claim_form/supplier-deduction`,
        method: "put",
        params
    })
// /claim_form/deduction-method // 获取抵扣方式
export const getDeductionMethod = () =>
    request({
        url: `/claim_form/deduction-method`,
        method: "get"
    });
// /claim_form/claim_reason // 获取索赔原因
export const getClaimReason = () =>
    request({
        url: `/claim_form/claim_reason`,
        method: "get"
    });
// /claim_form/{id}/excel // 下载索赔单
export const downloadClaimExcel = (id) =>
    download({
        responseType: "blob",
        url: `/claim_form/${id}/excel`,
        method: "get"
    });

// /credit-note/claim-form
// 获取索赔关联CN
export const getClaimFormCNCode = () =>
    request({
        url: `/credit-note/claim-form-list`,
        method: "get"
    });

// 表单上传工具--索赔单动态表头
// /credit-note/table-header
export const getCNTableHeader = () =>
    request({
        url: `/credit-note/table-header`,
        method: "get"
    });
// 上传索赔清单
// /credit-note/{id}/upload
export const uploadClaimTable = (id, data: any) =>
    request({
        url: `/credit-note/${id}/upload`,
        method: "post",
        data
    });

// 重新上传索赔清单
export const reUploadClaim = (id, data: any) =>
    request({
        url: `/credit-note/${id}/re-upload`,
        method: "post",
        data
    });

// 索赔金额抵扣-获取索赔单据
// /claim_form/codes
export const getClaimDJ = (params: any) =>
    request({
        url: `/claim_form/codes`,
        method: "get",
        params
    });

// 获取装箱单索赔信息
// /hq-packing-list/${id}/claim-info
export const getDeductionInfo = (id) =>
    request({
        url: `/claim_form/hq-packing-list/${id}/claim-info`,
        method: "get"
    });

//索赔金额抵扣-索赔单据抵扣信息
// /claim_form/claim-deduction-info
export const getClaimDeductionInfo = (params: any) =>
    request({
        url: `/claim_form/claim-deduction-info`,
        method: "get",
        params
    });

// 索赔单金额抵扣
// /claim_form/deduction-amount/purchase-order
export const putPurchaseOrder = (data: any) =>
    request({
        url: `/claim_form/deduction-amount`,
        method: "put",
        data
    });

// /claim_form/{id}/base-info
export const getClaimBaseInfo = (id) =>
    request({
        url: `/claim_form/${id}/base-info`,
        method: "get"
    });

// /claim_form/{id}/files
export const getClaimBaseFiles = (id) =>
    request({
        url: `/claim_form/${id}/files`,
        method: "get"
    });

// /claim_form/{id}/files
export const uploadClaimBaseFiles = (id, data) =>
    request({
        url: `/claim_form/${id}/files`,
        method: "post",
        data
    });

// /claim_form/files
export const deleteClaimFile = (params) =>
    request({
        url: `/claim_form/files`,
        method: "delete",
        params
    });

// /claim_form/{id}/deduction_details
export const getDeductionDetails = (id) =>
    request({
        url: `/claim_form/${id}/deduction_details`,
        method: "get"
    });

// /claim_form/supplierDeduction
export const putSupplierDeduction = (data: any) =>
    request({
        url: `/claim_form/supplierDeduction`,
        method: "put",
        data
    });

// /claim_form/{id}/write-off
export const putWriteOff = (id, params) =>
    request({
        url: `/claim_form/${id}/write-off`,
        method: "put",
        params
    });

//  /claim_form/{id}/write-off-details
export const getWriteOffDetails = (id) =>
    request({
        url: `/claim_form/${id}/write-off-details`,
        method: "get"
    });

// /claim_form/deduction-info
export const giveDeductionInfo = (data) =>
    request({
        url: `/claim_form/deduction-info`,
        method: "post",
        data
    });

//  /credit-note/{id}/download-claim-form-info
export const downloadClaimFormInfo = (id) =>
    request({
        // responseType: "blob",
        url: `/credit-note/${id}/claim-form-info`,
        method: "get"
    });

// 删除CN
// /credit-note/{id}
export const deleteCNData = (id) =>
    request({
        url: `/credit-note/${id}`,
        method: "delete"
    });

// 作废
export const invalidCN = (id) =>
    request({
        url: `/credit-note/${id}/invalid`,
        method: "put"
    });

//取消作废
export const cancelInvalidCN = (id) =>
    request({
        url: `/credit-note/${id}/cancel-invalid`,
        method: "put"
    })

export const abolished = (id) =>
    request({
        url: `/claim_form/${id}/abolished`,
        method: "put"
    });

export const updateClaimRemark = (id, data) =>
    request({
        url: `/claim_form/${id}/remark`,
        method: "put",
        data
    });

// 生成索赔单
// /claim_form/{id}/details
export const getCreateDetails = (id) =>
    request({
        url: `/claim_form/${id}/details`,
        method: "get"
    });

export const getCNState = () =>
    request({
        url: `/credit-note/all-state`,
        method: "get"
    });

// 获取采购订单关联索赔信息
export const getPurchaseOrderClaimInfo = (id: string) =>
    request({
        url: `/claim_form/purchase-order/${id}/claim-info`,
        method: "get"
    })
// 查询所有CN的验审状态
// /credit-note/all-audit-state
export const getAllAuditState = () =>
    request({
        url: `/credit-note/all-audit-state`,
        method: "get"
    })
// 查询所有的CN的单据类型
// /credit-note/all-cn-state
export const getAllCnState = () =>
    request({
        url: `/credit-note/all-cn-state`,
        method: "get"
    })
// 后端给的CNPDF
// /credit-note/{id}/export-pdf
export const serverrPDF = (id) =>
    download({
        responseType: "blob",
        url: `/credit-note/${id}/export-pdf`,
        method: "post"
    })

 //
  export const checkProductDeduction = (poInfoIds:string[]) =>
  request({
    url: `/claim_form/check-claim-deduction`,
    method: "POST",
    data:poInfoIds
  })

//修改CN备注
export const updateRemark = (id: string, data:any) =>
    request({
        url: `/credit-note/${id}/remark`,
        method: "PUT",
        data:data
    })

//手动平账
export const manualClearingAmount = (id: string, data:any) =>
    request({
        url: `/credit-note/${id}/manual_clearing_amount`,
        method: "PUT",
        data:{
            remark:data
        }
    });
// 查询CN的金额分配情况
export const queryAllocateDetail = (id: string) =>
    request({
        url: `/credit-note/${id}/allocate_detail`,
        method: "GET",
    });